import React, { Component } from "react";
import { Link } from "react-router-dom";

import PlayIcon from '@material-ui/icons/PlayCircleOutline';
import { generalS } from "../strings/general";
import { baseStyles } from "./baseStyles";
import VideoDialog from "./VideoDialog";
import 'youtube-video-js';

import "../styles/css/video.css";
import "../styles/css/popup.css";
import "../styles/css/main.css";

import { url } from '../inv';


class VideoManager extends Component {
  constructor(props) {
    super(props);
    this.state = { color: '#fff', open: false }
  }

  videoHandler = () => {
    this.setState({ open: true })
  }

  onMouseEnterHandler = () => {
    this.setState({ color: '#ffcc2a'})
  }

  onMouseLeaveHandler = () => {
    this.setState({ color: '#fff'})
  }

  render() {
    let { context, playSize, currentPost, post } = this.props;
    
    let { windowWidth } = context;
    let { open } = this.state;
    return(
      <div className={"video-container"}>
        <VideoDialog 
          videoLink={currentPost.value.video}
          onClose={() => {
            this.setState({ open: false })
          }} 
          open={open} 
          windowWidth={windowWidth} />
        <div className="video-image-container">
          {currentPost.value.video?
            <di className={"video-image-icon"}>
              <PlayIcon 
                style={{
                  cursor: "pointer",
                  fontSize: playSize, 
                  color: this.state.color
                }}
                onMouseEnter={this.onMouseEnterHandler}
                onMouseLeave={this.onMouseLeaveHandler}
                onClick={this.videoHandler}
              />
            </di>
          :("")}
           <img src={`${url}/public/${post.fileNames[0]}`} />
        </div>
      </div>
    );
  }
}

export default VideoManager;
